import { useTranslation } from 'react-i18next'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import CertificateTable from './CertificateTable'
import { useParams } from 'react-router-dom'
import { Button, Stack, useTheme } from '@mui/material'
import { useState } from 'react'
import { ProductCertificationFilters } from 'src/generated-types/product-certification'
import { AutoFixHigh } from '@mui/icons-material'
import { useDialogCtx, useUserCtx } from 'src/hooks/context-hooks'
import { AICertificateUploadWizard } from 'src/screens/admin/product/product-certification/ai-upload/AICertificateUploadWizard'
import { permissionValue } from 'src/enums/permissionValue'

const CertificateDatabaseContainer = () => {
  const { t: translate } = useTranslation(['certificate', 'common', 'admin-sidebar', 'product-certification'])
  const { id: customerId } = useParams()
  const theme = useTheme()
  const [headerFilters, setHeaderFilters] = useState<ProductCertificationFilters>({})
  const { showDialog } = useDialogCtx()
  const { user } = useUserCtx()

  const isSystemAdmin =
    user?.permission != null &&
    (BigInt(user.permission) & BigInt(permissionValue.SystemAdminPermission)) ===
      BigInt(permissionValue.SystemAdminPermission)

  const onSmartUpload = async () => {
    await showDialog(
      AICertificateUploadWizard,
      {
        componentProps: {},
        opts: {
          maxWidth: false,
          fullWidth: true,
          PaperProps: { sx: { width: '95vw', maxWidth: '95vw' } },
        },
      },
      undefined,
      true,
    )
  }

  return (
    <Stack
      style={{ backgroundColor: theme.palette.backgroundMain[theme.palette.mode] }}
      minHeight={window.innerHeight - 155}
      className="pb-4-core"
      minWidth={'100%'}
    >
      <CommonPageLayout
        titleSection={{ title: translate('certificate-database', { ns: 'admin-sidebar' }) }}
        topAction={
          isSystemAdmin
            ? [
                <Button key="smart-upload" variant="contained" startIcon={<AutoFixHigh />} onClick={onSmartUpload}>
                  {translate('smartUpload', { ns: 'product-certification' })}
                </Button>,
              ]
            : undefined
        }
      >
        <CertificateTable
          customerId={customerId as EntityId}
          headerFilters={headerFilters}
          setHeaderFilters={setHeaderFilters}
        />
      </CommonPageLayout>
    </Stack>
  )
}

export default CertificateDatabaseContainer
